// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const resetSearchFilters = state =>
    SearchFilters.update(state, {
        $set: getWipDefaultState().pipCodeRequestSearchFilters
    });

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

export default (state = getWipDefaultState().pipCodeRequestSearchFilters, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PIP_CODE_REQUESTS_SEARCH_FILTERS]: resetSearchFilters,
        [actions.UPDATE_TCSM_PIP_CODE_REQUESTS_FILTER_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_DIRECTION]: updateSearchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/pip-code-request-search-filters.js